export const onNavigate = (callback: () => void): (() => void) => {
	const listeners: (() => void)[] = [];

	// Deliberately synchronous: this is a generic navigation primitive, and its
	// callback republishes the current app and organization. Deferring it would
	// stamp every event fired in the meantime with the previous app. Callers that
	// want to collapse a burst debounce their own side effect, not this.
	const notify = () => callback();

	if (window.navigation && typeof window.navigation.addEventListener === 'function') {
		// Use currententrychange instead of navigate — navigate fires BEFORE the URL
		// updates, so getCurrentOrganization() would read the old URL.
		// currententrychange fires AFTER the entry (and URL) has been updated.
		window.navigation.addEventListener('currententrychange', notify);
		listeners.push(() => window.navigation.removeEventListener('currententrychange', notify));
	} else {
		window.addEventListener('popstate', notify);
		window.addEventListener('hashchange', notify);

		listeners.push(() => window.removeEventListener('popstate', notify));
		listeners.push(() => window.removeEventListener('hashchange', notify));

		// Intercept pushState / replaceState
		const intercept = (type: 'pushState' | 'replaceState') => {
			const original = history[type];
			const patched = function (
				this: any,
				...args: [data: any, unused: string, url?: string | URL | null]
			) {
				original.apply(this, args);
				notify();
			};
			history[type] = patched;
			listeners.push(() => {
				history[type] = original;
			});
		};

		intercept('pushState');
		intercept('replaceState');
	}

	// Cleanup function
	return () => {
		listeners.forEach(remove => remove());
	};
};
